import { UserActionRequiredMessage } from "@sgwt-widget/components-base";
import {
  h,
  initializeWidgetConfiguration,
  SgWidget,
  WidgetConfigurationProvider,
  WithGlobalCss,
} from "@sgwt-widget/core";
import { props } from "skatejs";
import { getInvalidParameters } from "../common/utils/AuditTrace/base/baseComponent.service";
import { ICprSnapshotProps } from "../common/utils/AuditTrace/types";

import { SnapshotCompareContainer } from "./component/snapshot-compare.component";

export class CprSnapshotCompare extends SgWidget<ICprSnapshotProps> {
  public static is = "cpr-snapshot-compare";

  public static props = {
    filters: props.object,
    userEmail: props.string,
  };

  public render(io: ICprSnapshotProps) {
    const invalidParams = getInvalidParameters(io);
    const headers = { uiscreen: (this.constructor as any).is };
    if (invalidParams.length > 0) {
      const message = `Please enter values for the following fields: ${invalidParams.join(
        ", "
      )}.`;
      return <UserActionRequiredMessage message={message} />;
    }
    return (
      <WidgetConfigurationProvider
        widgetConfiguration={this.widgetConfiguration}
      >
        <WithGlobalCss>
          <SnapshotCompareContainer filters={io.filters} headers={headers} />
        </WithGlobalCss>
      </WidgetConfigurationProvider>
    );
  }
}

initializeWidgetConfiguration(CprSnapshotCompare, {
  disablejQuerySanityCheck: true,
});
customElements.define(CprSnapshotCompare.is, CprSnapshotCompare);
